"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPaymentClick = trackPaymentClick;
var _analytics = require("@cian/analytics");
function trackPaymentClick(type, isBankMortgage) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'open_modal_payment_type',
    products: [{
      extra: {
        type,
        source: 'DifferentPrices',
        is_bank_mortgage: isBankMortgage
      }
    }]
  });
}